import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[_c(VCol,[_c('div',{staticClass:"loader text-center"},[_c(VProgressCircular,{attrs:{"size":"70","width":"7","indeterminate":"","color":"primary"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }